
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ManageCustomerPage from "../../../../../entities/DashboardPage/AccountingModule/Customer/ManageCustomer";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";

const ManageCustomer = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);

  // Get refresh trigger from navigation state
  const location = useLocation();
  const shouldRefresh = location.state?.refresh;

  useEffect(() => {
    getCustomerList("", "", page);
  }, [page, shouldRefresh])

  const getCustomerList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCustomer(text, sort, page);
      if (result?.success) {
        setData(result?.data?.customers);
        setTotal(result?.data?.total);

        LoaderHelper.loaderStatus(false);

        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteCustomers(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);

        getCustomerList();
        // console.slog(result?.success,"new employe data ---")
      } else {
        LoaderHelper.loaderStatus(false);
        // showAlert(result?.message,"error")

      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      //   showAlert(error,"success")
      // Handle error
      //   alertErrorMessage(error);
    }
  };
  const handleFilter = (text, sort) => {
    text ? getCustomerList(text) : sort ? getCustomerList("", sort) : null
  }


  return (
    <ManageCustomerPage page={page} total={total} setPage={setPage} data={data} handleFilter={handleFilter} handleDelete={handleDelete} />
  )

}

export default ManageCustomer;
